/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import IntegrationsacuityAcuityIntegration1 from './IntegrationsacuityAcuityIntegration1';

/**
 * The IntegrationsAcuityBody1 model module.
 * @module model/IntegrationsAcuityBody1
 * @version v0.3
 */
export default class IntegrationsAcuityBody1 {
  /**
   * Constructs a new <code>IntegrationsAcuityBody1</code>.
   * @alias module:model/IntegrationsAcuityBody1
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>IntegrationsAcuityBody1</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationsAcuityBody1} obj Optional instance to populate.
   * @return {module:model/IntegrationsAcuityBody1} The populated <code>IntegrationsAcuityBody1</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IntegrationsAcuityBody1();
      if (data.hasOwnProperty('acuity_integration'))
        obj.acuityIntegration = IntegrationsacuityAcuityIntegration1.constructFromObject(data['acuity_integration']);
    }
    return obj;
  }
}

/**
 * @member {module:model/IntegrationsacuityAcuityIntegration1} acuityIntegration
 */
IntegrationsAcuityBody1.prototype.acuityIntegration = undefined;

